import React from 'react';
import { Stack } from 'new/elements/Stack';
import classes from 'new/components/settings/VendorBuilder/VendorBuilder.module.scss';
import { useVendorBuilder } from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { Button } from 'new/elements/Button';
import { CodeRounded } from '@mui/icons-material';
import LoadableMonacoEditor from 'js/components/elements/editors/monaco/LoadableMonacoEditor';
import { useDebouncedCallback } from 'new/hooks/useDebouncedCallback';
import Typography from 'new/elements/Typography';

interface DynamicConfigValuesProps {
  path: string;
}

const dataTypes = [
  {
    title: 'Number',
    value: 'number',
  },
  {
    title: 'String',
    value: 'string',
  },
  {
    title: 'Boolean',
    value: 'boolean',
  },
];

const booleanValues = [
  {
    title: 'True',
    value: true,
  },
  {
    title: 'False',
    value: false,
  },
];

type KeyValuePairProps = {
  index: number;
  path: string;
};

const monacoOptions = {
  minimap: { enabled: false },
};

// const KeyValuePair = (props: KeyValuePairProps) => {
//   const { index, path } = props;
//   const { updateVendor } = useVendorBuilder();
//   const [type, setType] = useState('string');
//
//   const onChangeType = (e) => {
//     const { value } = e.target;
//     setType(value);
//   };
//
//   const onChange = (e) => {
//     const { name, value } = e.target;
//     updateVendor((newVendor) => {
//       newVendor.dynamicValues[path][index][name] = value;
//     });
//   };
//
//   const onRemove = () => {
//     updateVendor((newVendor) => {
//       newVendor.dynamicValues[path].splice(index, 1);
//     });
//   };
//
//   return (
//     <Stack className={classes.keyValuePairContainer}>
//       <Stack position="absolute" top="8px" right="8px">
//         <IconButton color="error" onClick={onRemove}>
//           <DeleteIcon />
//         </IconButton>
//       </Stack>
//       <Grid container spacing={2}>
//         <Grid item xs={4}>
//           <Select
//             fullWidth
//             label="Data Type"
//             defaultValue={type}
//             items={dataTypes}
//             name="data_type"
//             onChange={onChangeType}
//           />
//         </Grid>
//         <Grid item xs={8}>
//           <TextField label="Key" name="key" onChange={onChange} />
//         </Grid>
//       </Grid>
//       {['number', 'string'].includes(type) ? (
//         <TextField label="Value" name="value" onChange={onChange} />
//       ) : (
//         <Select
//           label="Value"
//           name="value"
//           items={booleanValues}
//           onChange={onChange}
//         />
//       )}
//     </Stack>
//   );
// };

export const DynamicConfigValues = (props: DynamicConfigValuesProps) => {
  const { path } = props;
  const { vendor, updateVendor } = useVendorBuilder();
  const dynamicObj = vendor.dynamicValues[path];

  const toggleShow = () => {
    updateVendor((newVendor) => {
      if (dynamicObj) {
        delete newVendor.dynamicValues[path];
      } else {
        newVendor.dynamicValues[path] = {};
      }
    });
  };

  const onChangeDynamicValues = useDebouncedCallback(
    (text: string) => {
      try {
        const values = JSON.parse(text);
        updateVendor((newVendor) => {
          newVendor.dynamicValues[path] = values;
        });
      } catch (e) {}
    },
    [vendor.dynamicValues],
    700,
  );

  return (
    <Stack gap="16px">
      {dynamicObj ? (
        <>
          <LoadableMonacoEditor
            language={'json'}
            value={JSON.stringify(dynamicObj) || '{}'}
            theme="solarizedDark"
            height={200}
            onChange={onChangeDynamicValues}
            options={monacoOptions}
          />
        </>
      ) : null}
      <Stack alignItems="flex-start">
        <Button
          startIcon={<CodeRounded />}
          color={dynamicObj ? 'error' : 'primary'}
          onClick={toggleShow}
        >
          {dynamicObj ? 'Reset' : 'Add'} custom key/value pairs in <code>vendor.{path}</code>
        </Button>
        <Stack className={classes.tip}>
          <Typography variant="body2">
            Override the generated content in <code>vendor.{path}</code> by adding key/value pairs
            with the desired property values.
            <br />
            <i>
              This object only helps add / update values in <b>vendor.{path}</b>. In case you wish
              to drop some properties pleae do it in the spec you are submitting on Github.
            </i>
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
